// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__lypxW","overlayFadeIn":"Modal_overlayFadeIn__WVMq+","modal":"Modal_modal__MEQp-","modalScaleIn":"Modal_modalScaleIn__DBEZ2"};